import React, { useEffect, useState } from "react";
import { deleteNotice } from "common-lib";
import { toast } from "react-toastify";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Grid, Pagination, CircularProgress } from "@mui/material";
import MouseClickList from "../MouseClickList.tsx";
import { useNavigate } from "react-router-dom";

export default function NoticeTable({ receivedData, setRefresh, loading, setCount, total, currentPage, setPage }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedNoticeId, setSelectedNoticeId] = useState(null);
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const navigate = useNavigate();
  const columns = [
    { field: "id", headerName: "No.", width: 100 },
    { field: "title", headerName: "Title", width: 200 },
    { field: "content", headerName: "Content", width: 400 },
    { field: "user_name", headerName: "Author", width: 160 },
    { field: "update_at", headerName: "Update", width: 120 },
  ];

  const handleEdit = async (row) => {
    navigate(`/notice/${selectedNoticeId}`);
  };

  const handleDelete = async (row) => {
    try {
      const confirm = window.confirm("정말로 해당 게시글을 삭제하시겠습니까?");
      if (!confirm) return;
      await deleteNotice(selectedNoticeId, userInfo.id);
      toast.success("게시글이 삭제되었습니다.");
      setRefresh(true);
      handleClose();
    } catch (error) {
      toast.error(error.response?.data?.message || "Error deleting notice");
      handleClose();
    }
  };

  const handleContextMenu = (event) => {
    event.preventDefault();
    const selectedNoticeId = event.currentTarget.getAttribute("data-id");
    setAnchorEl(event.currentTarget);
    setOpen(true);
    setSelectedNoticeId(Number(selectedNoticeId));
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  return (
    <>
      {loading ? (
        <CircularProgress />
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Grid container sx={{ mt: 3 }}>
            <DataGrid
              hideFooter
              hideFooterPagination
              disableColumnMenu
              disableColumnSorting
              rows={receivedData}
              columns={columns}
              getRowId={(row) => row.id}
              slotProps={{
                row: {
                  onContextMenu: handleContextMenu,
                  style: { cursor: "context-menu" },
                },
              }}
              // onRowClick={handleDetailClick}
              sx={{
                "& .MuiDataGrid-columnHeader": {
                  backgroundColor: "var(--dg-table-header-bg-color)",
                  color: "#fff",
                },
                "& .MuiDataGrid-filler": {
                  backgroundColor: "var(--dg-table-header-bg-color)",
                  color: "#fff",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "bold",
                },
                "& .MuiDataGrid-virtualScrollerContent": {
                  backgroundColor: "white",
                },
                "& .MuiDataGrid-cell": {
                  cursor: "pointer",
                  backgroundColor: "var(--unselected-row-bg)",
                  color: "var(--dg-color)",
                },
              }}
            />

            <MouseClickList
              anchorEl={anchorEl}
              open={open}
              category="insp_rule"
              // existModuleIds={existModuleIds}
              onClose={handleClose}
              onEdit={handleEdit}
              onDelete={handleDelete}
              // onModuleDelete={handleModuleDelete}
            />
            {/* {isModalOpen && (
                      <TrainModal
                        open={isModalOpen}
                        onClose={handleCloseModal}
                        state={state}
                        selectTrain={selectedTrain}
                      />
                    )} */}
          </Grid>
          <Pagination
            count={Math.ceil(total / 10)}
            page={currentPage}
            onChange={(_, value) => setPage(value)}
            color="primary"
            size="medium"
            sx={{ mt: 2, display: "flex", justifyContent: "center" }}
          />
        </Box>
      )}
    </>
  );
}
